/**
 * Main entry point for the plugin's JavaScript.
 */
import { initAddressSynchronizer } from './modules/address-synchronizer';
import { initUniqueEmailValidation } from './modules/unique-email';
import { initEmailDomainValidation } from './modules/email-domain-validation';
import { initTranslationToggle } from "./modules/language-switcher";
import { setDefaultTicketQuantity } from "./modules/set-default-ticket";

document.addEventListener('DOMContentLoaded', () => {
    initAddressSynchronizer();
    initUniqueEmailValidation();
    initEmailDomainValidation();
    initTranslationToggle();
    setTimeout(() => {
        setDefaultTicketQuantity();
    }, 100);
});
